const MONTHS = ['янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'];

/** 'YYYY-MM' → 'авг'. Формат месяца задаёт сервер, разбирать датой незачем. */
export function monthLabel(month: string): string {
  const index = Number(month.slice(5, 7)) - 1;
  return MONTHS[index] ?? month;
}

/** 'YYYY-MM' → 'август 2026' — для подписи в подсказке. */
export function monthFullLabel(month: string): string {
  const label = monthLabel(month);
  return `${label} ${month.slice(0, 4)}`;
}

/** Разделитель тысяч — числа портфеля бывают шестизначными. */
export function formatNumber(value: number): string {
  return value.toLocaleString('ru-RU');
}

/**
 * «сегодня» / «вчера» / «3 дн. назад» / дата — лента событий читается быстрее,
 * когда свежее время написано словами, а старое — обычной датой.
 */
export function relativeDay(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';

  const startOfDay = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
  const days = Math.round((startOfDay(new Date()) - startOfDay(date)) / 86_400_000);

  if (days <= 0) return 'сегодня';
  if (days === 1) return 'вчера';
  if (days < 7) return `${days} дн. назад`;

  return date.toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: '2-digit' });
}
